<template>
  <v-container class="elo">
    <div v-if="isLoading">
      <LoadingGandalf />
    </div>
    <div v-else>
      <!-- Solo la clasificación: el ELO de cada uno, con su gráfica, está en su ficha de jugador -->
      <v-tabs v-model="tab" color="primary" grow>
        <v-tab value="Individual"> Individual </v-tab>
        <!-- <v-tab value="Mensual"> Mensual </v-tab> -->
        <v-tab value="Equipos"> Equipos </v-tab>
      </v-tabs>

      <v-tabs-window v-model="tab">
        <!-- TAB 1. -->
        <v-tabs-window-item value="Individual" v-if="tab === 'Individual'">
          <TablaClasificacionElo class="separated" :items="eloClasificacion" />
        </v-tabs-window-item>

        <!-- TAB 3. -->
        <v-tabs-window-item value="Equipos" v-if="tab === 'Equipos'">
          <TablaClasificacionEloEquipos
            class="separated"
            :items="eloClasificacion"
            :facciones="facciones"
          />
        </v-tabs-window-item>
      </v-tabs-window>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import TablaClasificacionElo from "@/components/Elo/TablaClasificacionElo.vue";
import TablaClasificacionEloEquipos from "@/components/Elo/TablaClasificacionEloEquipos.vue";
import { UsuarioEloTablaClasificacion } from "@/interfaces/Elo";
import { FaccionDTO } from "@/interfaces/Faccion";
import { getFacciones } from "@/services/FaccionesService";
import { onMounted, ref } from "vue";
import { useAuth } from "@/composables/useAuth";
import { useRouter } from "vue-router";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { useEloStore } from "@/store/elo";

const eloStore = useEloStore();

const tab = ref<string>("Individual");

const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<number>(parseInt(getidUsuario.value));
const error = ref<string | null>(null);
const router = useRouter();
const idUsuario = ref<number>();
const isLoading = ref<boolean>(true);
const eloClasificacion = ref<UsuarioEloTablaClasificacion[]>([]);
const facciones = ref<FaccionDTO[]>([]);

onMounted(async () => {
  isLoading.value = true;
  try {
    // Obtener el usuario
    const id = idUsuarioLogger.value;
    if (!id) {
      error.value = "No se pudo obtener el usuario. Por favor, inicie sesión.";
      router.push({ name: "error" });
      return;
    }
    idUsuario.value = id;

    // Hacer peticiones en paralelo
    const [clasificacionEloData, faccionesResponse] = await Promise.all([
      eloStore.fetchClasificacionElo(),
      getFacciones(),
    ]);

    // Procesar la clasificación ELO
    eloClasificacion.value = clasificacionEloData.sort(
      (a: { elo: number }, b: { elo: number }) => b.elo - a.elo
    );
    eloClasificacion.value = eloClasificacion.value.map((item, index) => ({
      ...item,
      clasificacion: index + 1,
    }));

    // Procesar las facciones
    facciones.value = faccionesResponse.data;
  } catch (err) {
    console.error("Error al obtener datos del usuario:", error.value);
  } finally {
    isLoading.value = false;
  }
});
</script>

<style scoped>
/* En el ordenador, estrecha y centrada: se lee como en el móvil */
.elo {
  max-width: 720px;
}

.separated {
  margin-bottom: 20px;
}
</style>
